'use client';

import { useCacheKey, useOptimizely } from '@libs/common-next';
import { Fold } from './fold';
import { Controls } from './controls';
import { Docs } from './docs';
import { Experiments } from './experiments';
import { parseFlags } from './utils';
import type { DataFile } from './types';
import css from './devtools.module.scss';

export function DevTools() {
    const ck = useCacheKey();
    const { instance } = useOptimizely();
    const debug = ck.headers.has('x-petm-ts-debug');
    const dataFile: DataFile = JSON.parse(
        instance?.getOptimizelyConfig()?.getDatafile() ?? '{}'
    );

    if (!debug || !Object.keys(dataFile).length) return null;
    const experiments = Object.values(parseFlags(dataFile));

    return (
        <Fold>
            <div className={css.wrapper}>
                <Controls total={experiments.length} />
                <Experiments flags={experiments} />
                <Docs />
            </div>
        </Fold>
    );
}
